import { render, staticRenderFns } from "./ValidatePatient.vue?vue&type=template&id=4c2204a7&scoped=true&"
import script from "./ValidatePatient.vue?vue&type=script&lang=js&"
export * from "./ValidatePatient.vue?vue&type=script&lang=js&"
import style0 from "./ValidatePatient.vue?vue&type=style&index=0&id=4c2204a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2204a7",
  null
  
)

export default component.exports